<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router'
import BackgroundMusic from './modules/app/components/BackgroundMusic.vue'
import { appFeatures } from './modules/app';


appFeatures.debugAppBus()

// State -----------------------------------------
const backgroundMusicShow = $config.backgroundMusicShow

// Getters ---------------------------------------

// Methods ---------------------------------------

// Events ----------------------------------------

// Main Setup ------------------------------------

// -----------------------------------------------
</script>

<template>
  <BackgroundMusic v-show="backgroundMusicShow" />

  <router-view v-slot="{ Component }">
    <transition name="fade-view" mode="out-in">
      <component ref="viewRef" :is="Component" />
    </transition>
  </router-view>
</template>

<style scoped>
/* ------------------------ */
.fade-view-enter-active,
.fade-view-leave-active {
  transition: opacity 0.3s ease;
}
.fade-view-enter-from,
.fade-view-leave-to {
  opacity: 0;
}
/* ------------------------ */
header {
  line-height: 1.5;
  max-height: 100vh;
}
/* ------------------------ */
nav {
  width: 100%;
  font-size: 12px;
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

nav a.router-link-exact-active {
  color: var(--color-text);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}
/* ------------------------ */
</style>
